import { isAnnualMaskSale, subscribeAnnualMaskSaleCases } from "../../components/Followup/annualMaskSaleNodeAccess";
import { AnnualMaskReceiptDateText } from "../../components/Followup/AnnualMaskReceiptDate";
import PatientPortalTicketNotifications from "../../components/PatientPortal/PatientPortalTicketNotifications";
import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";

import { Link, NavLink, Redirect } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Image
import profile from "../../../images/profile/17.jpg";
import profile2 from "../../../images/profile/pic1.jpg";
import avatar from "../../../images/avatar/1.jpg";
import moneyBag from "../../../images/money-bag.png";
import { set } from "date-fns/esm";
import { functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";
import { useAuth } from "../../../context/AuthContext";
import { db, storage } from "../../../firebase";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  getDocs,
  collection,
  collectionGroup,
  where,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import {
  filterRecordsByStaffCustomerAccess,
  isStaffCustomerScopedUser,
} from "../../../utils/staffCustomerAccess";
import { filterBookingsForSaleAccess } from "../../components/Booking/BookingSaleAccess";
import { getBookingReportReadinessMap } from "../../components/Booking/BookingReportChecklistUtils";
import {
  ANNUAL_MASK_ACCESS_COLLECTION,
  ANNUAL_MASK_BATCHES_COLLECTION,
  ANNUAL_MASK_CASES_COLLECTION,
  ANNUAL_MASK_STATUS,
  getAnnualMaskSelectedSaleName,
  isAnnualMaskOrderComplete,
  normalizeAnnualMaskAccessEmail,
} from "../../components/Followup/annualMaskPurchaseUtils";

const SALE_FOLLOW_UP_NOTIFICATION_STATUSES = [
  "Sale Follow Up",
  "Sale Follow Up [MC]",
  "Sale Follow Up [STM]",
];

const READY_FOR_CPAP_PURCHASE_STATUS = "Ready for CPAP Purchase";

const SALE_NOTIFICATION_STATUSES = [
  ...SALE_FOLLOW_UP_NOTIFICATION_STATUSES,
  READY_FOR_CPAP_PURCHASE_STATUS,
];

// The ready work item remains visible while its Sale order is in progress.
// It is removed only after Sales marks that order เสร็จสิ้น.
const ANNUAL_MASK_NOTIFICATION_STATUSES = [
  ANNUAL_MASK_STATUS.READY_TO_PURCHASE,
  ANNUAL_MASK_STATUS.ORDER_CREATED,
];

const getSaleNotificationCaseKey = (booking = {}) => {
  const extendedProps = booking.extendedProps || {};

  return String(
    extendedProps.uuid ||
      booking.id ||
      [
        extendedProps.node,
        extendedProps.order,
        extendedProps.hn,
        extendedProps.latestSleepStudyDate,
      ].join("|"),
  );
};

const deduplicateSaleNotificationCases = (bookings = []) => {
  const uniqueBookings = new Map();

  bookings.forEach((booking) => {
    const key = getSaleNotificationCaseKey(booking);
    if (!uniqueBookings.has(key)) uniqueBookings.set(key, booking);
  });

  return Array.from(uniqueBookings.values());
};

const loadSaleNotificationReportReadiness = async (bookings = []) => {
  const hns = Array.from(
    new Set(
      bookings
        .map((booking) =>
          String(
            (booking.extendedProps && booking.extendedProps.hn) || "",
          ).trim(),
        )
        .filter(Boolean),
    ),
  );
  const reportResults = await Promise.all(
    hns.map(async (hn) => {
      try {
        const reportSnapshot = await getDocs(
          collection(db, "patients", hn, "report"),
        );
        return {
          hn,
          reports: reportSnapshot.docs.map((reportDoc) => {
            const reportData = reportDoc.data();
            return {
              id: reportDoc.id,
              ...reportData,
              hn: String(reportData.hn || hn).trim(),
            };
          }),
          unavailable: false,
        };
      } catch (error) {
        console.warn(
          "Unable to load report readiness for a sale notification case",
          error,
        );
        return { hn, reports: [], unavailable: true };
      }
    }),
  );
  const reportsByHn = reportResults.reduce((reportMap, result) => {
    reportMap[result.hn] = result.reports;
    return reportMap;
  }, {});
  const unavailableHns = new Set(
    reportResults
      .filter((result) => result.unavailable)
      .map((result) => result.hn),
  );
  const readinessByCaseId = getBookingReportReadinessMap(
    bookings,
    reportsByHn,
  );

  return bookings.map((booking) => {
    const extendedProps = booking.extendedProps || {};
    const hn = String(extendedProps.hn || "").trim();
    const readiness = readinessByCaseId[getSaleNotificationCaseKey(booking)];

    return {
      ...booking,
      reportReadiness:
        !hn || unavailableHns.has(hn) || !readiness
          ? { unavailable: true }
          : readiness,
    };
  });
};

const Header = ({
  onNote,
  toggle,
  onProfile,
  onNotification,
  onCpapPurchaseNotification,
  onAnnualMaskPurchaseNotification,
  onPatientPortalTicketNotification,
  onBox,
  onLogout,
  user,
}) => {
  const [fullScreen, setFullScreen] = useState(false);
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  const [sleepStudyCases, setSleepStudyCases] = useState(null);
  const [readyForCpapPurchaseCases, setReadyForCpapPurchaseCases] =
    useState(null);
  const [saleNotificationSearch, setSaleNotificationSearch] = useState("");
  const [cpapPurchaseNotificationSearch, setCpapPurchaseNotificationSearch] =
    useState("");
  const [technicianNotificationSearch, setTechnicianNotificationSearch] =
    useState("");
  const [physicianNotificationSearch, setPhysicianNotificationSearch] =
    useState("");
  const [technicianNotificationName, setTechnicianNotificationName] =
    useState("");
  const [annualMaskPurchaseCases, setAnnualMaskPurchaseCases] = useState([]);
  const [annualMaskPurchaseLoading, setAnnualMaskPurchaseLoading] =
    useState(true);
  const [annualMaskPurchaseSearch, setAnnualMaskPurchaseSearch] =
    useState("");
  const [hasAnnualMaskAccess, setHasAnnualMaskAccess] = useState(false);
  const [annualMaskAccessSubject, setAnnualMaskAccessSubject] = useState("");
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(0);
  // const [nodeList, setNodeList] = useState([]);
  const [nodeInfo, setNodeInfo] = useState([]);
  const canShowCaseNotifications =
    user &&
    Array.isArray(user.roles) &&
    !user.roles.includes("accountant") &&
    !user.roles.includes("staff");
  const isSaleUser =
    user && Array.isArray(user.roles) && user.roles[0] === "sale";
  const isPhysicianUser =
    user && Array.isArray(user.roles) && user.roles[0] === "sleep_physician";
  const isTechnicianNameMatchedNotificationUser =
    user &&
    Array.isArray(user.roles) &&
    !user.roles.includes("sale") &&
    !user.roles.includes("sleep_physician");
  const isCompactNotificationUser =
    isSaleUser || isTechnicianNameMatchedNotificationUser || isPhysicianUser;
  const annualMaskEmail = normalizeAnnualMaskAccessEmail(user && user.email);
  const annualMaskAccessSubjectKey = annualMaskEmail;
  const hasCurrentAnnualMaskAccess =
    hasAnnualMaskAccess &&
    annualMaskAccessSubject === annualMaskAccessSubjectKey;
  const canShowAnnualMaskPurchaseNotifications =
    hasCurrentAnnualMaskAccess && Boolean(annualMaskEmail);

  // console.log(currentUser);
  //   var finalName = filterName.includes("app")
  //     ? filterName.filter((f) => f !== "app")
  //     : filterName.includes("ui")
  //     ? filterName.filter((f) => f !== "ui")
  //     : filterName.includes("uc")
  //     ? filterName.filter((f) => f !== "uc")
  //     : filterName.includes("basic")
  //     ? filterName.filter((f) => f !== "basic")
  //     : filterName.includes("form")
  //     ? filterName.filter((f) => f !== "form")
  //     : filterName.includes("table")
  //     ? filterName.filter((f) => f !== "table")
  //     : filterName.includes("page")
  //     ? filterName.filter((f) => f !== "page")
  //     : filterName.includes("email")
  //     ? filterName.filter((f) => f !== "email")
  //     : filterName.includes("ecom")
  //     ? filterName.filter((f) => f !== "ecom")
  //     : filterName.includes("chart")
  //     ? filterName.filter((f) => f !== "chart")
  //     : filterName.includes("editor")
  //     ? filterName.filter((f) => f !== "editor")
  //     : filterName;
  var finalName = filterName.includes("admin")
    ? filterName.filter((f) => f !== "admin")
    : filterName.includes("node")
      ? filterName.filter((f) => f !== "node")
      : filterName.includes("booking")
        ? filterName.filter((f) => f !== "booking")
        : filterName.includes("followup")
          ? filterName.filter((f) => f !== "followup")
          : filterName.includes("patient")
            ? filterName.filter((f) => f !== "patient")
            : filterName.includes("cpap")
              ? filterName.filter((f) => f !== "cpap")
              : filterName.includes("product")
                ? filterName.filter((f) => f !== "product")
                : filterName;
  //   console.log(`path: ${finalName}`);
  const onFullScreen = () => {
    var elem = document.documentElement;
    setFullScreen(elem ? true : false);

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };
  const offFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setFullScreen(false);
  };
  const dateString = (date) => {
    return new Intl.DateTimeFormat("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    }).format(date);
  };

  const roundAwayFromZero = (value) =>
    value < 0 ? Math.floor(value) : Math.ceil(value);

  const renderSaleReportReadiness = (caseElement) => {
    const readiness = caseElement.reportReadiness;

    if (!readiness) {
      return (
        <div className="mt-1">
          <span className="badge badge-light">
            <i className="fa fa-spinner fa-spin mr-1" />
            Checking report files
          </span>
        </div>
      );
    }

    if (readiness.unavailable) {
      return (
        <div className="mt-1">
          <span className="badge badge-secondary">
            <i className="fa fa-question-circle mr-1" />
            Report file status unavailable
          </span>
        </div>
      );
    }

    const missingPartLabels = Array.isArray(readiness.missingPartLabels)
      ? readiness.missingPartLabels.join(", ")
      : "";

    return (
      <div className="mt-1">
        <span
          className={`badge ${
            readiness.isReady ? "badge-success" : "badge-warning"
          }`}
          title={
            readiness.isReady
              ? "All required report files are uploaded."
              : `Waiting for: ${missingPartLabels}`
          }
        >
          <i
            className={`fa ${
              readiness.isReady ? "fa-check-circle" : "fa-clock-o"
            } mr-1`}
          />
          {readiness.isReady
            ? "Report files ready"
            : "Report files not ready"}
        </span>
        {!readiness.isReady && missingPartLabels && (
          <small className="d-block mt-1">
            Waiting: {missingPartLabels}
          </small>
        )}
      </div>
    );
  };

  const renderSaleNotificationCaseList = ({
    cases,
    searchValue,
    onSearchChange,
    emptyMessage,
    showReportReadiness = true,
    showTechnicianDeadline = false,
    showPhysicianDetails = false,
  }) => {
    const notificationCases = Array.isArray(cases) ? cases : [];
    const normalizedSearch = searchValue.trim().toLocaleLowerCase();
    const visibleCases = notificationCases
      .filter((caseElement) => {
        if (!normalizedSearch) return true;

        const extendedProps = caseElement.extendedProps || {};
        return [
          extendedProps.order,
          caseElement.title,
          extendedProps.hn,
          extendedProps.firstname,
          extendedProps.lastname,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase()
          .includes(normalizedSearch);
      })
      .slice()
      .sort((left, right) =>
        String(
          (right.extendedProps && right.extendedProps.latestSleepStudyDate) ||
            "",
        ).localeCompare(
          String(
            (left.extendedProps &&
              left.extendedProps.latestSleepStudyDate) ||
              "",
          ),
        ),
      );

    return (
      <>
        <div className="input-group input-group-sm mb-2">
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">
              <i className="fa fa-search" />
            </span>
          </div>
          <input
            type="search"
            className="form-control"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search order, HN, or patient"
            aria-label="Search notification cases"
          />
          {searchValue && (
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => onSearchChange("")}
                aria-label="Clear notification search"
              >
                <i className="fa fa-times" />
              </button>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="text-muted">
            Showing {visibleCases.length} of {notificationCases.length} cases
          </small>
          {searchValue && (
            <small className="text-muted">Filtered results</small>
          )}
        </div>

        {visibleCases.length === 0 ? (
          <div className="border rounded p-3 text-center text-muted">
            {normalizedSearch ? "No cases match this search" : emptyMessage}
          </div>
        ) : (
          <div>
            {visibleCases.map((caseElement) => {
              const extendedProps = caseElement.extendedProps || {};
              const patientName = [
                extendedProps.firstname,
                extendedProps.lastname,
              ]
                .filter(Boolean)
                .join(" ");
              const bookingLabel =
                extendedProps.order || caseElement.title || "Booking";
              const status = extendedProps.status || (showPhysicianDetails ? "Not recorded" : "Sale Follow Up");
              const isCashCase = ["ชำระเงินเอง", "เงินสด"].includes(
                String(extendedProps.healthInsurance || "").trim(),
              );
              const statusColor =
                status === READY_FOR_CPAP_PURCHASE_STATUS
                  ? "#ff6f00"
                  : status === "Sale Follow Up [MC]"
                    ? "#6f42c1"
                    : status === "Sale Follow Up [STM]"
                      ? "#20a57a"
                      : "#3695eb";
              const dateLabel = extendedProps.latestSleepStudyDate
                ? `ตรวจเมื่อ ${extendedProps.latestSleepStudyDate}`
                : caseElement.startStr
                  ? `วันที่ของ event ${caseElement.startStr}`
                  : "";
              const deadline = Number(extendedProps.deadline);
              const hasDeadline = Number.isFinite(deadline);

              return (
                <div
                  key={getSaleNotificationCaseKey(caseElement)}
                  className="border rounded p-2 mb-2"
                  style={{
                    borderLeft: `4px solid ${statusColor}`,
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="pr-2" style={{ minWidth: 0 }}>
                      <div className="d-flex align-items-center">
                        {extendedProps.hn ? (
                          <Link style={{ minWidth: 0 }} to={`/patient-page/${extendedProps.hn}`}>
                            <strong className="d-block text-truncate">{patientName || bookingLabel}</strong>
                          </Link>
                        ) : (
                          <strong className="d-block text-truncate" style={{ minWidth: 0 }}>{patientName || bookingLabel}</strong>
                        )}
                        {showPhysicianDetails && (
                          <span
                            className="badge badge-light border ml-2"
                            title={extendedProps.type || "Study type not recorded"}
                            aria-label={extendedProps.type || "Study type not recorded"}
                          >
                            {{
                              "Full Night Sleep Study": "FN",
                              "Split Night Sleep Study": "SN",
                              "Home Full Night Sleep Study": "HFN",
                              "CPAP Titration": "CT",
                              "CPAP Titration Study": "CT",
                              "Overnight Pulse Oximetry Study": "OPO",
                              "Multiple Sleep Latency Test": "MSLT",
                            }[extendedProps.type] || extendedProps.type || "-"}
                          </span>
                        )}
                      </div>
                      <small className="d-block text-muted text-truncate">
                        {bookingLabel}
                        {extendedProps.hn && ` · ${extendedProps.hn}`}
                      </small>
                    </div>
                    <div className="d-flex flex-wrap justify-content-end">
                      <span
                        className="badge ml-2 mb-1"
                        style={{
                          backgroundColor: statusColor,
                          color: "#fff",
                          whiteSpace: "normal",
                          textAlign: "right",
                        }}
                      >
                        {status}
                      </span>
                      {isCashCase && (
                        <span
                          className="badge badge-success ml-2 mb-1"
                          title="Cash case (ชำระเงินเอง)"
                        >
                          <img
                            src={moneyBag}
                            alt=""
                            className="mr-1"
                            style={{ width: 14, height: 14 }}
                          />
                          Cash
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-wrap justify-content-between mt-1">
                    {(!showPhysicianDetails || extendedProps.phone) && <small className="mr-2">
                      <i className="fa fa-phone mr-1" />
                      {extendedProps.phone || "-"}
                    </small>}
                    {dateLabel && <small className="text-muted">{dateLabel}</small>}
                  </div>
                  {showPhysicianDetails && (
                    <div className="small text-muted mt-1">
                      {[extendedProps.node, extendedProps.customer].filter(Boolean).join(" · ")}
                    </div>
                  )}
                  {showReportReadiness ? (
                    renderSaleReportReadiness(caseElement)
                  ) : (
                    <div className="d-flex flex-wrap align-items-center mt-1">
                      {showTechnicianDeadline && hasDeadline && (
                        <small className="mr-2">
                          <i className="fa fa-clock-o mr-1" />
                          {roundAwayFromZero(deadline)} Days Left
                        </small>
                      )}
                      {caseElement.hurry ? (
                        <span className="badge badge-danger mr-2">
                          <i
                            className="fa fa-exclamation-triangle mr-1"
                            aria-hidden="true"
                          />
                          Emergency
                        </span>
                      ) : caseElement.alert ? (
                        <span className="badge badge-warning mr-2">
                          Warning
                        </span>
                      ) : null}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  const renderAnnualMaskPurchaseNotificationList = () => {
    const normalizedSearch = annualMaskPurchaseSearch
      .trim()
      .toLocaleLowerCase();
    const visibleCases = annualMaskPurchaseCases.filter((caseItem) => {
      if (!normalizedSearch) return true;
      const patient = caseItem.patient || caseItem;
      return [
        caseItem.batchName,
        caseItem.hn,
        patient.firstnameTh || patient.firstname,
        patient.lastnameTh || patient.lastname,
        caseItem.selectedMask && caseItem.selectedMask.itemName,
        caseItem.selectedMask && caseItem.selectedMask.size,
        getAnnualMaskSelectedSaleName(caseItem),
        caseItem.saleOrderReceiptNo,
      ]
        .filter(Boolean)
        .join(" ")
        .toLocaleLowerCase()
        .includes(normalizedSearch);
    });

    return (
      <>
        <div className="input-group input-group-sm mb-2">
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">
              <i className="fa fa-search" />
            </span>
          </div>
          <input
            type="search"
            className="form-control"
            value={annualMaskPurchaseSearch}
            onChange={(event) => setAnnualMaskPurchaseSearch(event.target.value)}
            placeholder="Search batch, HN, patient, mask, or sales"
            aria-label="Search Annual Mask Purchase notifications"
          />
        </div>
        {visibleCases.length === 0 ? (
          <div className="border rounded p-3 text-center text-muted">
            {normalizedSearch
              ? "No Annual Mask cases match this search"
              : "No Annual Mask Purchase cases need action"}
          </div>
        ) : (
          visibleCases.map((caseItem) => {
            const patient = caseItem.patient || caseItem;
            const name = [
              patient.firstnameTh || patient.firstname,
              patient.lastnameTh || patient.lastname,
            ]
              .filter(Boolean)
              .join(" ");
            const selectedMask = caseItem.selectedMask || {};
            const selectedSaleName = getAnnualMaskSelectedSaleName(caseItem);

            return (
              <div className="border rounded p-2 mb-2" key={caseItem.id}>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="pr-2" style={{ minWidth: 0 }}>
                    <Link to={`/patient-page/${caseItem.hn}`}>
                      <strong className="d-block text-truncate">
                        {name || caseItem.hn}
                      </strong>
                    </Link>
                    <small className="d-block text-muted text-truncate">
                      {caseItem.hn}
                      {caseItem.batchName ? ` · ${caseItem.batchName}` : ""}
                    </small>
                    <small className="d-block text-muted text-truncate">
                      {selectedMask.itemName || "Mask type not selected"}
                      {selectedMask.size ? ` · Size: ${selectedMask.size}` : ""}
                    </small>
                    <small className="d-block text-muted text-truncate">
                      Sales: {selectedSaleName || "Not selected"}
                    </small>
                    <small className="d-block"><AnnualMaskReceiptDateText date={caseItem.maskReceiptDate} /></small>
                    {caseItem.saleOrderReceiptNo && (
                      <small className="d-block text-muted text-truncate">
                        Order {caseItem.saleOrderReceiptNo}
                        {caseItem.saleOrderStatus
                          ? ` · ${caseItem.saleOrderStatus}`
                          : ""}
                      </small>
                    )}
                  </div>
                  <Link
                    to="/annual-mask-purchase"
                    className="btn btn-sm btn-outline-primary ml-2"
                  >
                    Open
                  </Link>
                </div>
              </div>
            );
          })
        )}
      </>
    );
  };

  useEffect(() => {
    setHasAnnualMaskAccess(false);
    setAnnualMaskAccessSubject("");

    if (!annualMaskEmail) return undefined;

    const unsubscribe = onSnapshot(
      doc(db, ANNUAL_MASK_ACCESS_COLLECTION, annualMaskEmail),
      (accessSnapshot) => {
        setHasAnnualMaskAccess(accessSnapshot.exists());
        setAnnualMaskAccessSubject(annualMaskAccessSubjectKey);
      },
      (error) => {
        console.warn("Unable to read Annual Mask Access", error);
        setHasAnnualMaskAccess(false);
        setAnnualMaskAccessSubject(annualMaskAccessSubjectKey);
      },
    );

    return () => unsubscribe();
  }, [annualMaskAccessSubjectKey, annualMaskEmail]);

  useEffect(() => {
    if (!canShowAnnualMaskPurchaseNotifications) {
      setAnnualMaskPurchaseCases([]);
      setAnnualMaskPurchaseLoading(false);
      return undefined;
    }

    if (isAnnualMaskSale(user)) {
      setAnnualMaskPurchaseCases([]);
      setAnnualMaskPurchaseLoading(true);
      return subscribeAnnualMaskSaleCases(db, user, (cases) => {
        setAnnualMaskPurchaseCases(cases.filter((caseItem) => ANNUAL_MASK_NOTIFICATION_STATUSES.includes(caseItem.status) && !isAnnualMaskOrderComplete(caseItem)));
        setAnnualMaskPurchaseLoading(false);
      }, (error) => {
        console.warn("Unable to load assigned-node Annual Mask notifications", error);
        setAnnualMaskPurchaseLoading(false);
      });
    }

    let active = true;
    let fallbackBatchUnsubscribe = null;
    const fallbackCaseUnsubscribes = new Map();
    const fallbackCasesByBatch = new Map();
    const fallbackBatchNames = new Map();
    let fallbackBatchIds = new Set();

    const isNotificationCase = (caseItem) =>
      ANNUAL_MASK_NOTIFICATION_STATUSES.includes(caseItem.status) &&
      !isAnnualMaskOrderComplete(caseItem);

    const publishFallbackCases = () => {
      if (
        !active ||
        !Array.from(fallbackBatchIds).every((batchId) =>
          fallbackCasesByBatch.has(batchId),
        )
      ) {
        return;
      }

      const cases = Array.from(fallbackBatchIds)
        .reduce(
          (allCases, batchId) =>
            allCases.concat(fallbackCasesByBatch.get(batchId) || []),
          [],
        )
        .filter(isNotificationCase);
      setAnnualMaskPurchaseCases(cases);
      setAnnualMaskPurchaseLoading(false);
    };

    const startAnnualMaskBatchFallback = () => {
      if (fallbackBatchUnsubscribe || !active) return;

      fallbackBatchUnsubscribe = onSnapshot(
        collection(db, ANNUAL_MASK_BATCHES_COLLECTION),
        (batchSnapshot) => {
          if (!active) return;

          const nextBatchIds = new Set(
            batchSnapshot.docs.map((batchDoc) => batchDoc.id),
          );
          fallbackBatchIds.forEach((batchId) => {
            if (nextBatchIds.has(batchId)) return;
            const unsubscribeCase = fallbackCaseUnsubscribes.get(batchId);
            if (unsubscribeCase) unsubscribeCase();
            fallbackCaseUnsubscribes.delete(batchId);
            fallbackCasesByBatch.delete(batchId);
            fallbackBatchNames.delete(batchId);
          });
          fallbackBatchIds = nextBatchIds;

          batchSnapshot.docs.forEach((batchDoc) => {
            fallbackBatchNames.set(
              batchDoc.id,
              String((batchDoc.data() || {}).batchName || "").trim(),
            );
            if (fallbackCaseUnsubscribes.has(batchDoc.id)) return;

            const unsubscribeCase = onSnapshot(
              collection(
                db,
                ANNUAL_MASK_BATCHES_COLLECTION,
                batchDoc.id,
                ANNUAL_MASK_CASES_COLLECTION,
              ),
              (caseSnapshot) => {
                fallbackCasesByBatch.set(
                  batchDoc.id,
                  caseSnapshot.docs.map((caseDoc) => {
                    const caseData = caseDoc.data();
                    return {
                      id: caseDoc.id,
                      ...caseData,
                      refPath: caseDoc.ref.path,
                      batchId: caseData.batchId || batchDoc.id,
                      batchName:
                        caseData.batchName ||
                        fallbackBatchNames.get(batchDoc.id) ||
                        "",
                    };
                  }),
                );
                publishFallbackCases();
              },
              (caseError) => {
                console.warn(
                  `Unable to load Annual Mask batch ${batchDoc.id} notifications`,
                  caseError,
                );
                fallbackCasesByBatch.set(batchDoc.id, []);
                publishFallbackCases();
              },
            );
            fallbackCaseUnsubscribes.set(batchDoc.id, unsubscribeCase);
          });

          publishFallbackCases();
        },
        (batchError) => {
          console.warn(
            "Unable to load Annual Mask notification fallback",
            batchError,
          );
          if (active) {
            setAnnualMaskPurchaseCases([]);
            setAnnualMaskPurchaseLoading(false);
          }
        },
      );
    };

    setAnnualMaskPurchaseLoading(true);
    const unsubscribe = onSnapshot(
      collectionGroup(db, ANNUAL_MASK_CASES_COLLECTION),
      (snapshot) => {
        const cases = snapshot.docs
          .map((caseDoc) => ({ id: caseDoc.id, ...caseDoc.data() }))
          .filter(isNotificationCase);

        if (active) {
          setAnnualMaskPurchaseCases(cases);
          setAnnualMaskPurchaseLoading(false);
        }
      },
      (error) => {
        console.warn("Unable to load Annual Mask Purchase notifications", error);
        startAnnualMaskBatchFallback();
      },
    );

    return () => {
      active = false;
      unsubscribe();
      if (fallbackBatchUnsubscribe) fallbackBatchUnsubscribe();
      fallbackCaseUnsubscribes.forEach((unsubscribeCase) => unsubscribeCase());
      fallbackCaseUnsubscribes.clear();
    };
  }, [canShowAnnualMaskPurchaseNotifications, annualMaskEmail, user && user.displayName, isAnnualMaskSale(user)]);

  useEffect(async () => {
    if (!canShowCaseNotifications) {
      setIsLoading(false);
      return;
    }

    if (sleepStudyCases != null) {
      setIsLoading(false);
      return;
    } else {
      if (user.roles[0] == "sleep_physician") {
        console.log("Fetching for physician user");
        const DoctorsQuery = query(
          collection(db, "doctors"),
          where("name", "==", user.displayName),
        );
        const DoctorDocuments = await getDocs(DoctorsQuery);
        const nodeQueries = new Map();
        const sleepStudyLists = await Promise.all(DoctorDocuments.docs.map(async (document) => {
          const doctorId = document.id;
          const doctorSleepStudyCasesRef = collection(
            db,
            `doctors/${doctorId}/sleepStudyCases`,
          );
          const sleepStudyQuery = await getDocs(doctorSleepStudyCasesRef);
          return Promise.all(sleepStudyQuery.docs.map(async (caseDoc) => {
            const caseData = caseDoc.data();
            let customer = caseData.customer || "";
            if (!customer && caseData.node && caseData.title) {
              try {
                if (!nodeQueries.has(caseData.node)) {
                  nodeQueries.set(caseData.node, getDocs(query(
                    collection(db, "nodes"), where("nodename", "==", caseData.node),
                  )));
                }
                const nodes = await nodeQueries.get(caseData.node);
                const snapshots = await Promise.all(nodes.docs.map((nodeDoc) => getDocs(query(
                  collection(db, "nodes", nodeDoc.id, "bookings"),
                  where("title", "==", caseData.title),
                ))));
                const matchingBookings = snapshots.flatMap((snapshot) => snapshot.docs)
                  .map((bookingDoc) => bookingDoc.data().extendedProps || {})
                  .filter((booking) => booking.doctor === user.displayName &&
                    (!caseData.latestSleepStudyDate || booking.latestSleepStudyDate === caseData.latestSleepStudyDate));
                const customers = [...new Set(matchingBookings.map((booking) => booking.customer).filter(Boolean))];
                if (customers.length === 1) customer = customers[0];
              } catch (error) {
                console.warn("Unable to load physician notification customer", error);
              }
            }
            return { ...caseData, id: caseDoc.id, extendedProps: { ...caseData, customer } };
          }));
        }));
        const sleepStudyList = sleepStudyLists.flat();
        setSleepStudyCases(sleepStudyList);
        setCount(sleepStudyList.length);
      } else if (user.roles[0] == "sale") {
        try {
          const nodesDocs = await getDocs(collection(db, "nodes"));
          const allNodeInfo = nodesDocs.docs.map((nodeDoc) => ({
            id: nodeDoc.id,
            ...nodeDoc.data(),
          }));
          const adminSnapshot = await getDoc(
            doc(db, "admins", user.displayName),
          );
          const adminData = adminSnapshot.exists()
            ? adminSnapshot.data()
            : {};
          const assignedNodeCodes = Array.isArray(adminData.node)
            ? adminData.node
            : adminData.node
              ? [adminData.node]
              : [];
          const assignedNodes = allNodeInfo.filter((nodeData) =>
            assignedNodeCodes.includes(nodeData.nodecode),
          );
          setNodeInfo(assignedNodes);

          const bookingSnapshots = await Promise.all(
            assignedNodes
              .filter((nodeData) => nodeData.nodename)
              .map((nodeData) =>
                getDocs(
                  query(
                    collectionGroup(db, "bookings"),
                    where(
                      "extendedProps.status",
                      "in",
                      SALE_NOTIFICATION_STATUSES,
                    ),
                    where(
                      "extendedProps.node",
                      "==",
                      nodeData.nodename,
                    ),
                    orderBy("extendedProps.latestSleepStudyDate", "asc"),
                  ),
                ),
              ),
          );

          const fetchedBookings = bookingSnapshots.reduce(
            (bookings, bookingSnapshot) => [
              ...bookings,
              ...bookingSnapshot.docs.map((bookingDoc) => ({
                id: bookingDoc.id,
                ...bookingDoc.data(),
                extendedProps: {
                  ...(bookingDoc.data().extendedProps || {}),
                },
              })),
            ],
            [],
          );
          const visibleBookings = deduplicateSaleNotificationCases(
            filterBookingsForSaleAccess({
              records: fetchedBookings,
              currentUser: user,
              assignedNodes,
            }),
          ).sort((left, right) =>
            String(
              (right.extendedProps &&
                right.extendedProps.latestSleepStudyDate) ||
                "",
            ).localeCompare(
              String(
                (left.extendedProps &&
                  left.extendedProps.latestSleepStudyDate) ||
                "",
              ),
            ),
          );

          const saleFollowUpCases = visibleBookings.filter((booking) =>
            SALE_FOLLOW_UP_NOTIFICATION_STATUSES.includes(
              booking.extendedProps && booking.extendedProps.status,
            ),
          );
          const readyForCpapPurchaseBookings = visibleBookings.filter(
            (booking) =>
              booking.extendedProps &&
              booking.extendedProps.status === READY_FOR_CPAP_PURCHASE_STATUS,
          );

          setSleepStudyCases(saleFollowUpCases);
          setReadyForCpapPurchaseCases(readyForCpapPurchaseBookings);
          setCount(saleFollowUpCases.length);
          setIsLoading(false);

          const bookingsWithReadiness =
            await loadSaleNotificationReportReadiness(visibleBookings);

          setSleepStudyCases(
            bookingsWithReadiness.filter((booking) =>
              SALE_FOLLOW_UP_NOTIFICATION_STATUSES.includes(
                booking.extendedProps && booking.extendedProps.status,
              ),
            ),
          );
          setReadyForCpapPurchaseCases(
            bookingsWithReadiness.filter(
              (booking) =>
                booking.extendedProps &&
                booking.extendedProps.status ===
                  READY_FOR_CPAP_PURCHASE_STATUS,
            ),
          );
        } catch (error) {
          console.error("Unable to load sale notifications", error);
          setSleepStudyCases([]);
          setReadyForCpapPurchaseCases([]);
          setCount(0);
          setIsLoading(false);
        }
      } else {
        console.log("Fetching for non-physician user");
        console.log("user: ", user);

        const nodesDocs = await getDocs(collection(db, "nodes"));
        // const allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        const nodeInfo = nodesDocs.docs.map((nodeDoc) => ({
          id: nodeDoc.id,
          ...nodeDoc.data(),
        }));
        setNodeInfo(nodeInfo);
        let staffAdminProfile = null;
        if (isStaffCustomerScopedUser(user)) {
          const adminSnap = await getDoc(
            doc(db, "admins", user.displayName),
          );
          staffAdminProfile = adminSnap.exists() ? adminSnap.data() : null;
        }
        var userName = user.displayName;
        const arrayOfName = [
          "Cia",
          "Film",
          "Kate",
          "Moria",
          "Hala",
          "Pareploy",
          "Preeyakorn",
        ];
        const arrayOfFullName = [
          "A.Rafa",
          "S.Kannika",
          "S.Areerut",
          "A.Hala",
          "A.Hala",
          "R.Pareploy",
          "P.Preeyakorn",
        ];
        if (arrayOfName.includes(user.displayName)) {
          userName = arrayOfFullName[arrayOfName.indexOf(user.displayName)];
        }

        try {
          const technicianSnapshot = await getDocs(
            collection(db, "sleeptechnicians"),
          );
          const normalizeTechnicianName = (value) =>
            String(value || "").trim().toLocaleLowerCase();
          const currentDisplayName = normalizeTechnicianName(
            user.displayName,
          );
          const matchingTechnician = technicianSnapshot.docs
            .map((technicianDoc) => technicianDoc.data())
            .find((technician) => {
              const technicianName = normalizeTechnicianName(
                technician && technician.name,
              );
              const technicianNickname = normalizeTechnicianName(
                technician && technician.nickname,
              );

              return (
                currentDisplayName &&
                (technicianName === currentDisplayName ||
                  technicianNickname === currentDisplayName)
              );
            });
          const matchedTechnicianName = String(
            matchingTechnician && matchingTechnician.name,
          ).trim();

          if (matchedTechnicianName) userName = matchedTechnicianName;
        } catch (error) {
          console.warn(
            "Unable to resolve technician name for header notifications",
            error,
          );
        }

        setTechnicianNotificationName(String(userName || "").trim());

        if (!String(userName || "").trim()) {
          setSleepStudyCases([]);
          setCount(0);
          setIsLoading(false);
          return;
        }

        const todayDateKey = new Date().toISOString().split("T")[0];
        const recordingTechnicianBookingsQuery = query(
          collectionGroup(db, "bookings"),
          where("extendedProps.techrecord", "==", userName),
          where(
            "extendedProps.latestSleepStudyDate",
            "<=",
            todayDateKey,
          ),
          where("extendedProps.status", "==", "Sleep Test Scheduled"),
        );
        const scoringTechnicianBookingsQuery = query(
          collectionGroup(db, "bookings"),
          where("extendedProps.technician", "==", userName),
        );

        const [recordingTechnicianSnapshot, scoringTechnicianSnapshot] =
          await Promise.all([
            getDocs(recordingTechnicianBookingsQuery),
            getDocs(scoringTechnicianBookingsQuery),
          ]);
        const notificationBookingsByPath = new Map();
        [
          ...recordingTechnicianSnapshot.docs,
          ...scoringTechnicianSnapshot.docs,
        ].forEach((bookingDoc) => {
          const booking = bookingDoc.data();
          const extendedProps = booking.extendedProps || {};

          if (
            extendedProps.status === "Sleep Test Scheduled" &&
            String(extendedProps.latestSleepStudyDate || "") <= todayDateKey
          ) {
            notificationBookingsByPath.set(bookingDoc.ref.path, {
              id: bookingDoc.id,
              ...booking,
            });
          }
        });

        const todayDate = new Date();

        const visibleNotificationCases = filterRecordsByStaffCustomerAccess({
          records: Array.from(notificationBookingsByPath.values()),
          currentUser: user,
          adminData: staffAdminProfile,
          nodes: nodeInfo,
          getNodeValue: (booking) =>
            booking.extendedProps && booking.extendedProps.node,
          getCustomerValue: (booking) =>
            booking.extendedProps && booking.extendedProps.customer,
        });

        var filteredData = visibleNotificationCases
          .map((data) => {
            const {
              healthInsurance,
              latestSleepStudyDate,
              status,
              node,
              postDoctor,
            } = data.extendedProps || {};
            const latestSleepStudyDateObj = new Date(latestSleepStudyDate);

            // Calculate deadline days
            let calculateDaysInitial =
              healthInsurance === "ชำระเงินเอง"
                ? 7
                : nodeInfo.find((n) => n.nodename === node).dueDays || 30;

            if (latestSleepStudyDateObj > todayDate) return null;

            const daysDiff =
              (todayDate - latestSleepStudyDateObj) / (1000 * 60 * 60 * 24);

            let alert = false;
            let hurry = false;

            if (healthInsurance === "ชำระเงินเอง") {
              if (daysDiff > calculateDaysInitial - 1 && daysDiff < 8) {
                alert = true;
              } else if (daysDiff > calculateDaysInitial + 1) {
                alert = true;
                hurry = true;
              }
            } else {
              if (
                daysDiff > 0.7 * calculateDaysInitial &&
                daysDiff < calculateDaysInitial
              ) {
                alert = true;
              } else if (daysDiff > calculateDaysInitial) {
                alert = true;
                hurry = true;
              }
            }
            if (
              alert == false &&
              hurry == false &&
              postDoctor == "P.Sasikarn"
            ) {
              alert = true;
            }

            data.extendedProps.deadline = calculateDaysInitial - daysDiff;

            return {
              ...data,
              alert,
              hurry,
            };
          })
          .filter(Boolean)
          .filter((data) => {
            const { healthInsurance, latestSleepStudyDate, status, node } =
              data.extendedProps || {};
            const daysDiff =
              (todayDate - new Date(latestSleepStudyDate)) /
              (1000 * 60 * 60 * 24);
            let calculateDaysInitial =
              healthInsurance === "ชำระเงินเอง"
                ? 7
                : nodeInfo.find((n) => n.nodename === node).dueDays || 30;

            const statusConditions = [
              "Sleep Test Scheduled",
              "Transferred To Center",
              "Assigned",
              "Technician Scored",
              "Assigned to Doctor",
            ];

            return (
              daysDiff > 0.4 * calculateDaysInitial &&
              statusConditions.includes(status)
            );
          })
          .sort((a, b) => {
            // Sort by insurance type then by closest deadline
            if (
              a.extendedProps.healthInsurance === "ชำระเงินเอง" &&
              b.extendedProps.healthInsurance !== "ชำระเงินเอง"
            )
              return -1;
            if (
              a.extendedProps.healthInsurance !== "ชำระเงินเอง" &&
              b.extendedProps.healthInsurance === "ชำระเงินเอง"
            )
              return 1;

            return a.extendedProps.deadline - b.extendedProps.deadline;
          });

        filteredData = filteredData.filter(
          (d) =>
            d.extendedProps.healthInsurance === "ชำระเงินเอง" ||
            d.alert === true ||
            d.hurry === true,
        );
        setSleepStudyCases(filteredData);
        setCount(filteredData.length);
        // const statusFilter =
        //   selectedStatus === "ทั้งหมด"
        //     ? [
        //         "Sleep Test Scheduled",
        //         "Transferred To Center",
        //         "Assigned",
        //         "Technician Scored",
        //         "Assigned to Doctor",
        //       ]
        //     : [selectedStatus];

        // const finalFilteredData = filteredData.filter((d) =>
        //   statusFilter.includes(d.extendedProps.status),
        // );
      }
    }
  }, [canShowCaseNotifications, sleepStudyCases]);
  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left ">
              {/* <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {finalName.join(" ").length === 0
                  ? "Dashboard"
                  : finalName.join(" ")}
              </div> */}
            </div>

            <ul className="navbar-nav header-right">
              <li className="nav-item">
                <div className="input-group search-area d-lg-inline-flex d-none">
                  <h3>{dateString(new Date())}</h3>
                </div>
              </li>
              {/* *********** Search Started ********************* */}
              {/* <li className="nav-item">
                        <div className="input-group search-area d-lg-inline-flex d-none mr-5">
                           <input
                              type="text"
                              className="form-control"
                              placeholder="Search here"
                           />
                           <div className="input-group-append">
                              <span className="input-group-text">
                                 <svg
                                    width={20}
                                    height={20}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M23.7871 22.7761L17.9548 16.9437C19.5193 15.145 20.4665 12.7982 20.4665 10.2333C20.4665 4.58714 15.8741 0 10.2333 0C4.58714 0 0 4.59246 0 10.2333C0 15.8741 4.59246 20.4665 10.2333 20.4665C12.7982 20.4665 15.145 19.5193 16.9437 17.9548L22.7761 23.7871C22.9144 23.9255 23.1007 24 23.2816 24C23.4625 24 23.6488 23.9308 23.7871 23.7871C24.0639 23.5104 24.0639 23.0528 23.7871 22.7761ZM1.43149 10.2333C1.43149 5.38004 5.38004 1.43681 10.2279 1.43681C15.0812 1.43681 19.0244 5.38537 19.0244 10.2333C19.0244 15.0812 15.0812 19.035 10.2279 19.035C5.38004 19.035 1.43149 15.0865 1.43149 10.2333Z"
                                       fill="#A4A4A4"
                                    />
                                 </svg>
                              </span>
                           </div>
                        </div>
                     </li> */}
              {/* ************* Search Ended ********************** */}

              {/* ************* Notification Started ********************** */}
              {user && canShowCaseNotifications && (
                <li className="nav-item dropdown notification_dropdown">
                  {!isLoading && (
                    <>
                      {/* <Link
                        className="nav-link  ai-icon"
                        to="#"
                        role="button"
                        data-toggle="dropdown"
                        onClick={() => onNotification()}
                      >
                        <svg
                          width={28}
                          height={28}
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.75 15.8385V13.0463C22.7471 10.8855 21.9385 8.80353 20.4821 7.20735C19.0258 5.61116 17.0264 4.61555 14.875 4.41516V2.625C14.875 2.39294 14.7828 2.17038 14.6187 2.00628C14.4546 1.84219 14.2321 1.75 14 1.75C13.7679 1.75 13.5454 1.84219 13.3813 2.00628C13.2172 2.17038 13.125 2.39294 13.125 2.625V4.41534C10.9736 4.61572 8.97429 5.61131 7.51794 7.20746C6.06159 8.80361 5.25291 10.8855 5.25 13.0463V15.8383C4.26257 16.0412 3.37529 16.5784 2.73774 17.3593C2.10019 18.1401 1.75134 19.1169 1.75 20.125C1.75076 20.821 2.02757 21.4882 2.51969 21.9803C3.01181 22.4724 3.67904 22.7492 4.375 22.75H9.71346C9.91521 23.738 10.452 24.6259 11.2331 25.2636C12.0142 25.9013 12.9916 26.2497 14 26.2497C15.0084 26.2497 15.9858 25.9013 16.7669 25.2636C17.548 24.6259 18.0848 23.738 18.2865 22.75H23.625C24.321 22.7492 24.9882 22.4724 25.4803 21.9803C25.9724 21.4882 26.2492 20.821 26.25 20.125C26.2486 19.117 25.8998 18.1402 25.2622 17.3594C24.6247 16.5786 23.7374 16.0414 22.75 15.8385ZM7 13.0463C7.00232 11.2113 7.73226 9.45223 9.02974 8.15474C10.3272 6.85726 12.0863 6.12732 13.9212 6.125H14.0788C15.9137 6.12732 17.6728 6.85726 18.9703 8.15474C20.2677 9.45223 20.9977 11.2113 21 13.0463V15.75H7V13.0463ZM14 24.5C13.4589 24.4983 12.9316 24.3292 12.4905 24.0159C12.0493 23.7026 11.716 23.2604 11.5363 22.75H16.4637C16.284 23.2604 15.9507 23.7026 15.5095 24.0159C15.0684 24.3292 14.5411 24.4983 14 24.5ZM23.625 21H4.375C4.14298 20.9999 3.9205 20.9076 3.75644 20.7436C3.59237 20.5795 3.50014 20.357 3.5 20.125C3.50076 19.429 3.77757 18.7618 4.26969 18.2697C4.76181 17.7776 5.42904 17.5008 6.125 17.5H21.875C22.571 17.5008 23.2382 17.7776 23.7303 18.2697C24.2224 18.7618 24.4992 19.429 24.5 20.125C24.4999 20.357 24.4076 20.5795 24.2436 20.7436C24.0795 20.9076 23.857 20.9999 23.625 21Z"
                            fill="#555555"
                          />
                        </svg>

                        <span className="badge light text-white bg-primary">
                          {count}
                        </span>
                      </Link> */}
                      <Link
                        className="nav-link ai-icon"
                        to="#"
                        role="button"
                        data-toggle="dropdown"
                        onClick={onNotification}
                        style={{
                          backgroundColor: sleepStudyCases.some((c) => c.hurry)
                            ? "#dc3545"
                            : sleepStudyCases.some((c) => c.alert)
                              ? "#fd7e14"
                              : "transparent",
                          color: sleepStudyCases.some((c) => c.hurry)
                            ? "#fff"
                            : sleepStudyCases.some((c) => c.alert)
                              ? "#111"
                              : "inherit",
                        }}
                      >
                        <svg
                          width={28}
                          height={28}
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ color: "inherit" }}
                        >
                          <path
                            d="M22.75 15.8385V13.0463C22.7471 10.8855 21.9385 8.80353 20.4821 7.20735C19.0258 5.61116 17.0264 4.61555 14.875 4.41516V2.625C14.875 2.39294 14.7828 2.17038 14.6187 2.00628C14.4546 1.84219 14.2321 1.75 14 1.75C13.7679 1.75 13.5454 1.84219 13.3813 2.00628C13.2172 2.17038 13.125 2.39294 13.125 2.625V4.41534C10.9736 4.61572 8.97429 5.61131 7.51794 7.20746C6.06159 8.80361 5.25291 10.8855 5.25 13.0463V15.8383C4.26257 16.0412 3.37529 16.5784 2.73774 17.3593C2.10019 18.1401 1.75134 19.1169 1.75 20.125C1.75076 20.821 2.02757 21.4882 2.51969 21.9803C3.01181 22.4724 3.67904 22.7492 4.375 22.75H9.71346C9.91521 23.738 10.452 24.6259 11.2331 25.2636C12.0142 25.9013 12.9916 26.2497 14 26.2497C15.0084 26.2497 15.9858 25.9013 16.7669 25.2636C17.548 24.6259 18.0848 23.738 18.2865 22.75H23.625C24.321 22.7492 24.9882 22.4724 25.4803 21.9803C25.9724 21.4882 26.2492 20.821 26.25 20.125C26.2486 19.117 25.8998 18.1402 25.2622 17.3594C24.6247 16.5786 23.7374 16.0414 22.75 15.8385ZM7 13.0463C7.00232 11.2113 7.73226 9.45223 9.02974 8.15474C10.3272 6.85726 12.0863 6.12732 13.9212 6.125H14.0788C15.9137 6.12732 17.6728 6.85726 18.9703 8.15474C20.2677 9.45223 20.9977 11.2113 21 13.0463V15.75H7V13.0463ZM14 24.5C13.4589 24.4983 12.9316 24.3292 12.4905 24.0159C12.0493 23.7026 11.716 23.2604 11.5363 22.75H16.4637C16.284 23.2604 15.9507 23.7026 15.5095 24.0159C15.0684 24.3292 14.5411 24.4983 14 24.5ZM23.625 21H4.375C4.14298 20.9999 3.9205 20.9076 3.75644 20.7436C3.59237 20.5795 3.50014 20.357 3.5 20.125C3.50076 19.429 3.77757 18.7618 4.26969 18.2697C4.76181 17.7776 5.42904 17.5008 6.125 17.5H21.875C22.571 17.5008 23.2382 17.7776 23.7303 18.2697C24.2224 18.7618 24.4992 19.429 24.5 20.125C24.4999 20.357 24.4076 20.5795 24.2436 20.7436C24.0795 20.9076 23.857 20.9999 23.625 21Z"
                            fill="currentColor"
                          />
                        </svg>

                        <span className="badge light text-white bg-primary">
                          {count}
                        </span>
                      </Link>

                      <div
                        className={`dropdown-menu dropdown-menu-right ${
                          toggle === "notification" ? "show" : ""
                        }`}
                        style={
                          isCompactNotificationUser
                            ? { width: 480, maxWidth: "calc(100vw - 30px)" }
                            : undefined
                        }
                      >
                        {isSaleUser && (
                          <div className="px-3 py-2 border-bottom bg-white">
                            <h6 className="mb-0">Sale Follow Up</h6>
                            <small className="text-muted">
                              Cases waiting for sales follow-up
                            </small>
                          </div>
                        )}
                        {isTechnicianNameMatchedNotificationUser && (
                          <div className="px-3 py-2 border-bottom bg-white">
                            <h6 className="mb-0">My Assigned Cases</h6>
                            <small className="text-muted">
                              {technicianNotificationName
                                ? `Matched technician: ${technicianNotificationName}`
                                : "Cases assigned to you"}
                            </small>
                          </div>
                        )}
                        {isPhysicianUser && (
                          <div className="px-3 py-2 border-bottom bg-white">
                            <h6 className="mb-0">My Assigned Sleep Studies</h6>
                            <small className="text-muted">
                              Booking cases assigned for doctor review
                            </small>
                          </div>
                        )}
                        <PerfectScrollbar
                          id="DZ_W_Notification1"
                          style={{ maxHeight: 420 }} // <- adjust: 320/380/420/500
                          //height380
                          className={` widget-media dz-scroll p-3 ${
                            toggle === "notification" ? "ps ps--active-y" : ""
                          }`}
                        >
                          {isSaleUser ? (
                            renderSaleNotificationCaseList({
                              cases: sleepStudyCases,
                              searchValue: saleNotificationSearch,
                              onSearchChange: setSaleNotificationSearch,
                              emptyMessage: "No Sale Follow Up cases",
                            })
                          ) : isTechnicianNameMatchedNotificationUser ? (
                            renderSaleNotificationCaseList({
                              cases: sleepStudyCases,
                              searchValue: technicianNotificationSearch,
                              onSearchChange: setTechnicianNotificationSearch,
                              emptyMessage: "No assigned cases for your name",
                              showReportReadiness: false,
                              showTechnicianDeadline: true,
                            })
                          ) : isPhysicianUser ? (
                            renderSaleNotificationCaseList({
                              cases: sleepStudyCases,
                              searchValue: physicianNotificationSearch,
                              onSearchChange: setPhysicianNotificationSearch,
                              emptyMessage: "No sleep studies awaiting your review",
                              showReportReadiness: false,
                              showTechnicianDeadline: false,
                              showPhysicianDetails: true,
                            })
                          ) : (
                          <ul className="timeline">
                            {/* ===== empty state ===== */}
                            {sleepStudyCases.length === 0 &&
                              user.roles[0] !== "staff" && (
                                <li>
                                  <div className="timeline-panel">
                                    <div className="media-body">
                                      <h6 className="mb-1">All caught up 🎉</h6>
                                      <small className="d-block">
                                        เคลียร์เคสเร่งด่วนครบแล้ว เย้! 🎉 <br />
                                        ขอบคุณที่ช่วยดูแลงานครับ 🙏✨
                                      </small>
                                    </div>
                                  </div>
                                </li>
                              )}

                            {/* ===== encouragement (only show if have cases) ===== */}
                            {sleepStudyCases.length > 0 &&
                              !["staff", "sleep_physician", "sale"].includes(
                                user.roles[0],
                              ) &&
                              (() => {
                                const hasHurry = sleepStudyCases.some(
                                  (c) => c.hurry,
                                );
                                const hasAlert = sleepStudyCases.some(
                                  (c) => c.alert,
                                );

                                const title = hasHurry
                                  ? "ขอแรงนิดนึงครับ 🚀😄"
                                  : "ลุยกันต่อครับ 💪🙂";

                                const body = hasHurry ? (
                                  <>
                                    ตอนนี้มีเคสที่ควรรีบทำก่อนนะครับ ⏳⚡ <br />
                                    ขอจัดอันเร่งด่วนก่อน แล้วค่อยไล่ที่เหลือครับ
                                    🙌
                                  </>
                                ) : hasAlert ? (
                                  <>
                                    ยังมีเคสที่ใกล้ต้องจัดการรออยู่นะครับ 📝✨{" "}
                                    <br />
                                    จะอ่านเองหรือส่งเข้ากองกลางดีน้าาา ~~ 🤔💭
                                  </>
                                ) : (
                                  <>
                                    วันนี้ยังมีเคสรออยู่นะครับ 📝🙂 <br />
                                    ค่อยๆ ไล่ทีละเคส เดี๋ยวก็หมด! ✨
                                  </>
                                );

                                return (
                                  <li>
                                    <div className="timeline-panel">
                                      <div className="media-body">
                                        <h6 className="mb-1">{title}</h6>
                                        <small className="d-block">
                                          {body}
                                        </small>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })()}

                            {/* ===== cases list ===== */}
                            {sleepStudyCases
                              .slice() // avoid mutating state with sort
                              .sort((a, b) => {
                                const aCash =
                                  a.extendedProps.healthInsurance ===
                                  "ชำระเงินเอง";
                                const bCash =
                                  b.extendedProps.healthInsurance ===
                                  "ชำระเงินเอง";
                                if (aCash && !bCash) return -1;
                                if (!aCash && bCash) return 1;
                                return (
                                  a.extendedProps.deadline -
                                  b.extendedProps.deadline
                                );
                              })
                              .map((caseElement, index) => (
                                <li key={caseElement.id}>
                                  <div className="timeline-panel">
                                    <div
                                      className="mr-2 media media-dark"
                                      style={{
                                        borderRadius: "50%",
                                        fontSize: 12,
                                        fontWeight: 700,
                                        background: "#f1f3f5",
                                        color: "#343a40",
                                      }}
                                      title={`#${index + 1}`}
                                    >
                                      {index + 1}
                                    </div>

                                    <div className="media mr-2 media-info ">
                                      {caseElement.extendedProps.type ===
                                      "Full Night Sleep Study"
                                        ? "FN"
                                        : caseElement.extendedProps.type ===
                                            "Split Night Sleep Study"
                                          ? "SN"
                                          : caseElement.extendedProps.type ===
                                              "Home Full Night Sleep Study"
                                            ? "HFN"
                                            : caseElement.extendedProps.type ===
                                                  "CPAP Titration" ||
                                                caseElement.extendedProps
                                                  .type ===
                                                  "CPAP Titration Study"
                                              ? "CT"
                                              : caseElement.extendedProps
                                                    .type ===
                                                  "Overnight Pulse Oximetry Study"
                                                ? "OPO"
                                                : caseElement.extendedProps
                                                      .type ===
                                                    "Multiple Sleep Latency Test"
                                                  ? "[MSLT]"
                                                  : ""}
                                    </div>

                                    <div className="media-body">
                                      <h6 className="mb-1">
                                        {caseElement.title}{" "}
                                        {caseElement.extendedProps.status ==
                                        "Sale Follow Up [MC]"
                                          ? "[MC]"
                                          : caseElement.extendedProps.status ==
                                              "Sale Follow Up [STM]"
                                            ? "[STM]"
                                            : ""}{" "}
                                      </h6>
                                      <Link
                                        to={`/patient-page/${caseElement.extendedProps.hn}`}
                                      >
                                        <h6 className="mb-1">
                                          {`${caseElement.extendedProps.firstname} ${caseElement.extendedProps.lastname}`}
                                        </h6>
                                      </Link>

                                      {user.roles[0] == "sale" ? (
                                        <>
                                          <h6>
                                            Tel:{" "}
                                            {caseElement.extendedProps.phone}
                                          </h6>
                                          {renderSaleReportReadiness(
                                            caseElement,
                                          )}
                                        </>
                                      ) : (
                                        <h6>
                                          {roundAwayFromZero(
                                            caseElement.extendedProps.deadline,
                                          )}{" "}
                                          Days Left
                                        </h6>
                                      )}
                                      <div className="d-flex align-items-center gap-2">
                                        <small>
                                          {caseElement.extendedProps
                                            .latestSleepStudyDate
                                            ? `ตรวจเมื่อ ${
                                                caseElement.extendedProps
                                                  .latestSleepStudyDate
                                              }`
                                            : `วันที่ของ event ${caseElement.startStr}`}
                                          {` `}
                                        </small>
                                        <></>
                                        <small>
                                          {caseElement.extendedProps
                                            .healthInsurance ===
                                            "ชำระเงินเอง" && " 💰 "}
                                          {caseElement.alert &&
                                          !caseElement.hurry
                                            ? " ⏰ Warning"
                                            : caseElement.alert &&
                                                caseElement.hurry
                                              ? " 🚨 Emergency"
                                              : " "}
                                        </small>
                                        {caseElement.extendedProps
                                          .postDoctor === "P.Sasikarn" &&
                                          user.roles[0] !=
                                            "sleep_physician" && (
                                            <small>(* Dr. Sasikarn)</small>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                          )}
                        </PerfectScrollbar>
                        {/* <Link className="all-notification" to="#">
                      See all notifications <i className="ti-arrow-right" />
                    </Link> */}
                      </div>
                    </>
                  )}
                </li>
              )}

              {canShowCaseNotifications &&
                isSaleUser &&
                !isLoading &&
                readyForCpapPurchaseCases !== null && (
                  <li className="nav-item dropdown notification_dropdown">
                    <Link
                      className="nav-link ai-icon"
                      to="#"
                      role="button"
                      data-toggle="dropdown"
                      onClick={onCpapPurchaseNotification}
                      title="Ready for CPAP Purchase"
                      aria-label="Ready for CPAP Purchase notifications"
                      style={{ backgroundColor: "#ff6f00", color: "#fff" }}
                    >
                      <i
                        className="fa fa-shopping-cart"
                        aria-hidden="true"
                        style={{ fontSize: 22 }}
                      />
                      <span
                        className="badge light text-white"
                        style={{ backgroundColor: "#c65100" }}
                      >
                        {readyForCpapPurchaseCases.length}
                      </span>
                    </Link>

                    <div
                      className={`dropdown-menu dropdown-menu-right ${
                        toggle === "cpap-purchase-notification" ? "show" : ""
                      }`}
                      style={{ width: 480, maxWidth: "calc(100vw - 30px)" }}
                    >
                      <div
                        className="px-3 py-2 border-bottom"
                        style={{ backgroundColor: "#ff6f00", color: "#fff" }}
                      >
                        <h6 className="mb-0">Ready for CPAP Purchase</h6>
                        <small>Cases ready for a CPAP purchase discussion</small>
                      </div>
                      <PerfectScrollbar
                        id="DZ_W_CpapPurchaseNotification"
                        style={{ maxHeight: 420 }}
                        className={`widget-media dz-scroll p-3 ${
                          toggle === "cpap-purchase-notification"
                            ? "ps ps--active-y"
                            : ""
                        }`}
                      >
                        {renderSaleNotificationCaseList({
                          cases: readyForCpapPurchaseCases,
                          searchValue: cpapPurchaseNotificationSearch,
                          onSearchChange: setCpapPurchaseNotificationSearch,
                          emptyMessage: "No CPAP purchase-ready cases",
                        })}
                      </PerfectScrollbar>
                    </div>
                  </li>
                )}

              {canShowAnnualMaskPurchaseNotifications && (
                <li className="nav-item dropdown notification_dropdown">
                    <Link
                      className="nav-link ai-icon"
                      to="#"
                      role="button"
                      data-toggle="dropdown"
                      onClick={onAnnualMaskPurchaseNotification}
                      title="Annual Mask Purchase work queue"
                      aria-label="Annual Mask Purchase notifications"
                      style={{ backgroundColor: "#6f42c1", color: "#fff" }}
                    >
                      <i
                        className="fa fa-medkit"
                        aria-hidden="true"
                        style={{ fontSize: 21 }}
                      />
                      <span
                        className="badge light text-white"
                        style={{ backgroundColor: "#4a247f" }}
                      >
                        {annualMaskPurchaseLoading
                          ? "…"
                          : annualMaskPurchaseCases.length}
                      </span>
                    </Link>

                    <div
                      className={`dropdown-menu dropdown-menu-right ${
                        toggle === "annual-mask-purchase-notification"
                          ? "show"
                          : ""
                      }`}
                      style={{ width: 480, maxWidth: "calc(100vw - 30px)" }}
                    >
                      <div
                        className="px-3 py-2 border-bottom"
                        style={{ backgroundColor: "#6f42c1", color: "#fff" }}
                      >
                        <h6 className="mb-0 text-white">Annual Mask Purchase</h6>
                        <small>
                          Ready cases remain here until the Sale order is
                          marked เสร็จสิ้น
                        </small>
                      </div>
                      <PerfectScrollbar
                        id="DZ_W_AnnualMaskPurchaseNotification"
                        style={{ maxHeight: 420 }}
                        className={`widget-media dz-scroll p-3 ${
                          toggle === "annual-mask-purchase-notification"
                            ? "ps ps--active-y"
                            : ""
                        }`}
                      >
                        {annualMaskPurchaseLoading ? (
                          <div className="border rounded p-3 text-center text-muted">
                            Loading Annual Mask Purchase cases…
                          </div>
                        ) : (
                          renderAnnualMaskPurchaseNotificationList()
                        )}
                      </PerfectScrollbar>
                    </div>
                </li>
              )}

              {/* ************* Notification Ended ********************** */}
              <PatientPortalTicketNotifications
                open={toggle === "patient-portal-ticket-notification"}
                onToggle={onPatientPortalTicketNotification}
              />

              {fullScreen ? (
                <li
                  className="nav-item dropdown notification_dropdown "
                  onClick={() => offFullScreen()}
                >
                  <Link className="nav-link dz-fullscreen active" to="#">
                    <svg
                      id="icon-full"
                      viewBox="0 0 24 24"
                      width={26}
                      height={26}
                      stroke="currentColor"
                      strokeWidth={2}
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="css-i6dzq1"
                    >
                      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
                    </svg>
                    <svg
                      id="icon-minimize"
                      width={26}
                      height={26}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-minimize"
                    >
                      <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
                    </svg>
                  </Link>
                </li>
              ) : (
                <li className="nav-item dropdown notification_dropdown">
                  <Link
                    className="nav-link dz-fullscreen"
                    to="#"
                    onClick={() => onFullScreen()}
                  >
                    <svg
                      id="icon-full"
                      viewBox="0 0 24 24"
                      width={26}
                      height={26}
                      stroke="currentColor"
                      strokeWidth={2}
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="css-i6dzq1"
                    >
                      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
                    </svg>
                    <svg
                      id="icon-minimize"
                      width={26}
                      height={26}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-minimize"
                    >
                      <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
                    </svg>
                  </Link>
                </li>
              )}

              <Dropdown as="li" className="nav-item dropdown header-profile ">
                <Dropdown.Toggle
                  as={Link}
                  variant=""
                  className="nav-link i-false"
                  to="#"
                  role="button"
                  data-toggle="dropdown"
                >
                  {user ? (
                    <div className="header-info">
                      <span>{user.displayName}</span>
                      {user.roles.includes("super_admin") && (
                        <small>Super Admin</small>
                      )}
                      {user.roles.includes("admin") && <small>Admin</small>}
                      {user.roles.includes("staff") && <small>Staff</small>}
                      {user.roles.includes("patient") && <small>Patient</small>}
                      {user.roles.includes("sale") && <small>Sale</small>}
                      {user.roles.includes("accountant") && (
                        <small>Accountant</small>
                      )}
                      {user.roles.includes("sleep_technician") && (
                        <small>Sleep Technician</small>
                      )}
                      {user.roles.includes("sleep_physician") && (
                        <small>Sleep Physician</small>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {user ? (
                    <img
                      src={user.photoURL ? user.photoURL : "1.png"}
                      width={20}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  className="dropdown-menu dropdown-menu-right"
                >
                  <Link to="/" className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ml-2">Profile </span>
                  </Link>
                  {/* <Link to="/email-inbox" className="dropdown-item ai-icon">
                    <svg
                      id="icon-inbox"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-success"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <span className="ml-2">Inbox </span>
                  </Link> */}
                  <Link
                    to="/page-login"
                    className="dropdown-item ai-icon"
                    onClick={() => {
                      onLogout();
                    }}
                  >
                    <svg
                      id="icon-logout"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-danger"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1={21} y1={12} x2={9} y2={12} />
                    </svg>
                    <span className="ml-2">Logout </span>
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
